<template>
  <div class="mt-3">
    <div class="iq-card mb-3 mx-3" style="min-width: 300px;">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title py-3">
          <h4 class="card-title">Edit Role</h4>
        </div>
      </div>
      <div class="iq-card-body">
        <div class="row">
          <div role="group" class="form-group col-md-6">
            <label for="roleName" class="d-block form-label text-left">
              Name:
            </label>
            <div class="bv-no-focus-ring">
              <div role="group" class="input-group">
                <input class="form-control" type="text" id="roleName" placeholder="Role name"
                  v-model="data.roleName" :class="errors.roleName ? 'is-invalid' : ''">
                <b-form-invalid-feedback v-if="errors.roleName">
                  {{ Object.values(errors.roleName) }}
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group text-right">
          <b-button type="submit" @click="onSubmitEditClicked('Updated')" :disabled="isSubmit" variant="primary"
            size="sm" class="ml-1">
            <div class="mx-2">
              <i class="fa" :class="isSubmit ? 'ri-loader-line' : 'ri-save-line'"></i>
              Update Role Data
            </div>
          </b-button>
        </div>
      </div>
    </div>
    <div class="px-3">
      <relation-manager :config="permissionRelation" :parent-id="id" />
    </div>
  </div>
</template>

<script>
import RoleSvc from '@/services/RoleSvc';
import requestBuilder from '@/util/request.builder';

import RelationManager from '@/components/shared/RelationManager';
import { permissionRelation } from '@/components/userrole/role/relation-configs';

export default {
  name: 'RoleDetail',
  components: { RelationManager },
  computed: {
    permissionRelation: () => permissionRelation,
  },
  data() {
    return {
      data: {},
      errors: {},
      filter: {
        roleId: this.$route.params.id,
      },
      id: this.$route.params.id,
      isSubmit: false,
      pagination: {
        current: 1,
        pageSize: 1,
        totalSize: 0,
      },
    };
  },
  methods: {
    async getData(notification) {
      try {
        const res = await RoleSvc.getRoles({
          params: { ...requestBuilder.buildFilters(this.pagination, this.filter) },
        });
        [this.data] = res.data.data;
        if (notification) this.$toast.success(notification);
      } catch (e) {
        this.$toast.error('Error when fetching role data');
      }
    },
    async onSubmitEditClicked(notification) {
      this.errors = {};
      this.isSubmit = true;
      try {
        await RoleSvc.update(this.id, { roleName: this.data.roleName });
        await this.getData(notification);
      } catch (e) {
        this.$toast.error('Error when submitting');
      } finally {
        this.isSubmit = false;
      }
    },
  },
  async mounted() {
    await this.getData();
  },
};
</script>

<style scoped></style>
